import { render, staticRenderFns } from "./StatusMenu.vue?vue&type=template&id=dee96b62"
import script from "./StatusMenu.vue?vue&type=script&lang=js"
export * from "./StatusMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports